import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ISizeName } from '@df/core/service/client';
import { ImageModule } from '@df/module-image/image.module';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { ToggleComponent } from '../../../ui/form/toggle/toggle.component';
import { PRODUCT_SIZE_GUIDE_BLOCK_CONFIG } from './product-size-guide-modal.config';
import { NProductSizeGuideModal } from './product-size-guide-modal.interface';
@DfCmsModal({
    id: NProductSizeGuideModal.BLOCK_ID,
    name: 'Product Size Guide',
    position: (sizeId: ISizeName) => (sizeId === 'S' ? 'bottom' : undefined),
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        maxWidth: sizeId === 'S' || sizeId === 'M' ? '100%' : '80vw',
        width: sizeId === 'S' || sizeId === 'M' ? '100%' : '80vw',
        maxHeight: sizeId === 'S' || sizeId === 'M' ? '100%' : '90vh',
        modalClass: 'size-guide-modal'
    }),
    blockGroup: 'modals',
    priority: 20,
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['L', 'X'])
})
@ICmsComponent<ProductSizeGuideModalComponent>(PRODUCT_SIZE_GUIDE_BLOCK_CONFIG)
@Component({
    selector: 'product-size-guide-modal',
    templateUrl: './product-size-guide-modal.component.html',
    styleUrls: ['./product-size-guide-modal.component.scss'],
    standalone: true,
    imports: [ICmsClientModule, NgClass, ToggleComponent, FormsModule, ImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSizeGuideModalComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NProductSizeGuideModal.IBlockDataContent;

    @Input()
    variant?: string;

    protected tableOptions: boolean[] = [];

    constructor(private modalRef: ModalRef<any>) {
        super();
    }

    override ngOnInit(): void {
        this.updateTableOptions();
        super.ngOnInit();
    }

    override ngOnChanges(changes: any): void {
        this.updateTableOptions();
        super.ngOnChanges(changes);
    }

    protected close() {
        this.modalRef.close();
    }

    private updateTableOptions(): void {
        this.tableOptions = Array.from({ length: this.content?.tables?.length || 0 }, (v, i) => false);
    }
}
